import { createSlice } from "@reduxjs/toolkit";
import { browserRoutes } from "../../config/browserRoutes";

const initialState = {
  sideBar: {
    selectedKeys: [browserRoutes?.dashboard],
  },
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    updateSidebarSelectedKeys: (state, { payload }) => {
      state.sideBar.selectedKeys = payload;
    },
  },
});

export const { updateSidebarSelectedKeys } = uiSlice.actions;
